export default {
    workOrder_tab_advancedFilters_title: "Advanced Filters",
    workOrder_tab_advancedFilters_clearAll: "Clear All",
    workOrder_tab_advancedFilters_status: "Status",
    workOrder_tab_advancedFilters_scheduledDate: "Scheduled Date",
    workOrder_tab_advancedFilters_type: "Type",
    workOrder_tab_advancedFilters_severity: "Severity",
    workOrder_tab_advancedFilters_driver: "Driver",
};